<template>
  <transition name="fade">
    <div v-if="show" class="toast-container">
      <div class="toast-content">
        <span class="toast-text">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      show: false,
      message: '',
      timer: null
    };
  },
  methods: {
    toast(msg) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.message = msg;
      this.show = true;
      this.timer = setTimeout(() => {
        this.show = false;
        this.message = '';
      }, 1500);
    }
  }
};
</script>

<style lang="less" scoped>
.toast-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.toast-content {
  background: rgba(0, 0, 0, 0.5);
  padding: 20px 40px;
  border-radius: 8px;
}

.toast-text {
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
